module.exports = __webpack_public_path__ + "img/close.933779ba.svg";